import(/* webpackMode: "eager", webpackExports: ["default"] */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/careers/JobItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/Magnetic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn","Stagger"] */ "/workspace/components/ui/motion.tsx");
